import { cn } from '@/lib/utils'
import { Typo3Section, Typo3TitleLayout } from '@/types/typo3'
import { Button, Container, Richtext, Section, Title } from '@/ui/components'
import { ButtonProps } from '@/ui/components/Button/type'
import { getTitleTag } from '@/utils'
import { memo } from 'react'

export interface SectionCtaProps {
  section?: Typo3Section
  title?: string
  titleLayout?: Typo3TitleLayout
  buttons?: ButtonProps[]
  text?: string
  className?: string
}

const SectionCta = ({
  section,
  titleLayout,
  title,
  buttons,
  text,
  className
}: SectionCtaProps) => (
  <Section data={section} className={cn('s-section-cta py-5xl', className)}>
    <Container>
      <div className="gap-gutter bg-shop-300 px-padding-lg py-3xl grid text-neutral-100 lg:grid-cols-2">
        <header>
          <Title as={getTitleTag(titleLayout)} className="h2">
            {title}
          </Title>
        </header>
        <div className="gap-xl flex flex-col">
          <Richtext text={text} />
          {buttons && buttons?.length > 0 && (
            <div className="gap-gutter flex">
              {buttons.map((button, index) => (
                <Button key={index?.toString()} {...button} />
              ))}
            </div>
          )}
        </div>
      </div>
    </Container>
  </Section>
)

SectionCta.displayName = 'SectionCta'

export default memo(SectionCta)
